<template>
    <div id='NotificationList'>
        <div class='NotificationItem' v-for='(notification, idx) in notifications.slice().reverse()'
            :key='idx'
            :name='notification.message'
            :link='notification.link'
        >
            <a :href='notification.link'>{{notification.message}}</a>
            <button class='CloseNotification' @click='remove(notification)'>
                &times;
            </button>
        </div>
        <div class='AllNotifications'>
            <button class='btn btn-primary'>SEE MORE</button>
        </div>
    </div>
</template>

<script>
    export default{
        name: 'NotificationList',
        props:['notifications'],
        data(){
            return{
                notificationList: this.$props.notifications
            }
        },
        methods:{
            remove(removedNotification){
                //console.log("button pressed: " +removedNotification )
                this.$store.dispatch('Navigation/removeNotification', removedNotification);
            }
        }
    }
</script>
